if (!customElements.get('cart-price-change-notification-o2')) {
  customElements.define(
    'cart-price-change-notification-o2',
    class CartPriceChangeNotificationO2 extends HTMLElement {
      static acknowledging = false;

      connectedCallback() {
        this.button = this.querySelector('button');
        this.onAcknowledge = this.onAcknowledge.bind(this);
        this.button?.addEventListener('click', this.onAcknowledge);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onAcknowledge);
      }

      async onAcknowledge() {
        if (CartPriceChangeNotificationO2.acknowledging) return;
        CartPriceChangeNotificationO2.acknowledging = true;
        const noticeSelector = 'cart-price-change-notification-o2';
        const acknowledgedTokens = this.dataset.acknowledgedTokens;
        document.querySelectorAll(`${noticeSelector} button`).forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });
        document.querySelectorAll(`${noticeSelector} [role="alert"]`).forEach((error) => {
          error.hidden = true;
        });

        try {
          await window.O2CartAttributes.update({
            _o2_price_change_acknowledged: acknowledgedTokens,
          });

          document.querySelectorAll(noticeSelector).forEach((notice) => {
            const tokens = notice.dataset.acknowledgedTokens.split('|').filter(Boolean);
            notice.hidden = tokens.every((token) => acknowledgedTokens.includes(`|${token}|`));
          });

          document.querySelectorAll('[data-price-change-badge-o2]').forEach((badge) => {
            if (acknowledgedTokens.includes(badge.dataset.mismatchToken)) badge.hidden = true;
          });
        } catch (error) {
          console.error(error);
          document.querySelectorAll(noticeSelector).forEach((notice) => {
            const message = notice.querySelector('[role="alert"]');
            message.textContent = notice.dataset.errorMessage;
            message.hidden = false;
          });
        } finally {
          CartPriceChangeNotificationO2.acknowledging = false;
          document.querySelectorAll(`${noticeSelector} button`).forEach((button) => {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          });
        }
      }
    }
  );
}
